import React from "react";
import "./HelpCenterButton.styles.scss";
import { Dropdown, Nav } from "react-bootstrap";
import ToolTip from "components/ToolTip/ToolTip";
import { useAuthentication } from "hooks";
import { Permisos } from "utils/permisos";
import { URL_DOCUMENTACION } from "utils/constants";

export const HelpCenterButton = () => {
  const { logout, usuario: user, tienePermiso } = useAuthentication();

  const openInNewTab = (url) => {
    const win = window.open(url, "_blank", "noopener,noreferrer");
    win.focus();
  };

  return (
    <>
      <Dropdown as={Nav.Item}>
        <Dropdown.Toggle
          as={Nav.Link}
          id="dropdown-41471887333"
          style={{ fontSize: "20px" }}
          className="buttonHover"
        >
          <ToolTip placement="left" message="Centro de Ayuda">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 -960 960 960"
              fill="#77777A"
            >
              <path
                d="M504-257.03q11-11.03 11-27T503.97-311q-11.03-11-27-11T450-310.97q-11 11.03-11 27T450.03-257q11.03 11 27 11T504-257.03ZM444-394h57q0-31 10-50.5t34.72-44.22Q579-522 592-547.5t13-53.5q0-53-34-84t-91.52-31q-51.87 0-88.17 24.5Q355-667 338-624l53 22q14-28 36.2-42.5Q449.4-659 479-659q32 0 50.5 16t18.5 44.1q0 19.9-11 38.4T500-517q-37 35-46.5 60t-9.5 63ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
              />
            </svg>
          </ToolTip>
        </Dropdown.Toggle>
        <Dropdown.Menu alignRight aria-labelledby="navbarDropdownMenuLink">
          {tienePermiso(Permisos.Documentacion.DOCUMENTACION_ECF_VER) && <Dropdown.Item
            href="#"
            onClick={(e) => {
              e.preventDefault();
              openInNewTab("https://citrus.com.do/docs/ecf");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 -960 960 960"
              style={{ marginRight: "8px" }}
            >
              <path d="M180-180v-600 224-33 409Zm97-270h253.7q2.3-16 6.3-31t12-29H277v60Zm0 171h198q17-14 36.5-23.5T552-319v-20H277v60Zm0-342h406v-60H277v60Zm-97 501q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v345q0-37-16.5-68.5T780-556v-224H180v600h248v60H180Zm437.5-248.5Q590-396 590-435t27.5-66.5Q645-529 684-529t66.5 27.5Q778-474 778-435t-27.5 66.5Q723-341 684-341t-66.5-27.5ZM488-120v-51q0-26 11-44.5t31-28.5q37-19 75-28t79-9q41 0 79 8.5t75 28.5q20 9 31 28t11 45v51H488Z" />
            </svg>
            Documentación
          </Dropdown.Item>}

          {tienePermiso(Permisos.Documentacion.DOCUMENTACION_LISTAR) && <Dropdown.Item
            href="#"
            onClick={(e) => {
              e.preventDefault();
              openInNewTab(URL_DOCUMENTACION);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 -960 960 960"
              style={{ marginRight: "8px" }}
            >
              <path d="M170-360h76q12 0 21-9t9-21v-210h-48v192h-40v-52h-48v70q0 12 9 21t21 9Zm176 0h76q12 0 21-9t9-21v-79q0-12-9-21t-21-9h-58v-53h40v32h48v-50q0-12-9-21t-21-9h-76q-12 0-21 9t-9 21v79q0 12 9 21t21 9h58v53h-40v-32h-48v50q0 12 9 21t21 9Zm194-45v-150h44v150h-44Zm-18 48h80q12 0 21-9t9-21v-186q0-12-9-21t-21-9h-80q-12 0-21 9t-9 21v186q0 12 9 21t21 9Zm150 0h45v-132l53 132h50v-246h-45v133l-53-133h-50v246ZM100-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h760q24.75 0 42.38 18Q920-764 920-740v520q0 24-17.62 42-17.63 18-42.38 18H100Zm0-60h760v-520H100v520Zm0 0v-520 520Z" />
            </svg>
            Documentación API
          </Dropdown.Item>}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};
